<template>
  <div class="home-page">
    <shard-hero></shard-hero>
    <div class="legals">
      <ul>
        <li>
          <router-link to="/privacy-policy">
            <button>privacy policy</button>
          </router-link>
        </li>
        <li>
          <router-link to="/terms-of-service">
            <button>terms of service</button>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ShardHero from '@/components/shard-hero.vue'

export default {
  name: 'home-page',
  components: {
    ShardHero
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  height: 100%;
}

.legals {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1;
  opacity: .1;

  @media screen and (max-width: 500px) {
    left: 20px;
  }

  li {
    display: inline-block;
  }

  button {
    letter-spacing: 2px;
    background: transparent;
    border: none;
    padding: 7px 15px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: .7em;
    color: white;
    cursor: pointer;
    transition: all .2s ease-in-out;
    outline: none;

    &:hover {
      opacity: .8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-page.vue